"use client";

import React, { ReactNode } from "react";

type ContainerVariant =
  | "full-width"
  | "form"
  | "form-wide"
  | "detail"
  | "detail-wide";

interface PageContainerProps {
  /**
   * Container variant (kept for backwards compatibility, but all variants now use full width)
   * The layout already handles max-width and padding, so this component just wraps content
   */
  variant?: ContainerVariant;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Children to render inside container
   */
  children: ReactNode;
}

/**
 * Reusable container component for org slug pages
 * The layout already handles max-width (max-w-7xl) and padding, so this component
 * just provides a consistent wrapper without adding additional constraints
 */
export function PageContainer({
  children,
  className = "",
  variant: _variant = "full-width",
}: PageContainerProps) {
  // All variants now use full width - the layout handles max-width and padding
  return <div className={className}>{children}</div>;
}
